import { Box, Card, CircularProgress, IconButton, Stack, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CachedIcon from '@mui/icons-material/Cached';
import { disqualifiedAction } from '../../redux/toolkit/dashbaord/disqualified';
import CancelSharpIcon from '@mui/icons-material/CancelSharp';

export default function DisqualifiedAttempts() {
    // state
    const dispatch = useDispatch()
    const totalDisqualifiedSelector = useSelector(state => state.totalDisqualified)
    const { data, loading } = totalDisqualifiedSelector

    // fn
    const handleRefeash = () => {
        dispatch(disqualifiedAction())
    }

    // use effect
    useEffect(() => {
        dispatch(disqualifiedAction())
    }, [dispatch])

    return (
        <Card sx={{ p: 2, color:'#0C6A96' }} >
            <Stack direction='row' justifyContent='space-between' >
                <CancelSharpIcon/>
                <Typography sx={{ color: '#5E6C8A',fontFamily: 'Montserrat,sans-serif',fontStyle:'normal' }} variant='subtitle2'>Disqualified Attempts</Typography>
                <IconButton sx={{ color: '#5E6C8A' }} onClick={handleRefeash}><CachedIcon /></IconButton>
            </Stack>

            {
                loading
                    ? <CircularProgress />
                    : <Box>
                        <Typography variant='h3' color='primary' sx={{ fontWeight: 600, color: '#071D45' }}>{data?.no_of_mission_disqualified?data?.no_of_mission_disqualified:"---"}</Typography>
                    </Box>
            }
        </Card>
    )
}
